import { Injectable } from '@angular/core';
import { NotificationService } from '@progress/kendo-angular-notification';

@Injectable({
  providedIn: 'root'
})
export class GlobalNotificationService {

  constructor(private notificationService: NotificationService) { }

  showWarningNotification(message: string){
    this.notificationService.show({
      content: message,
      animation: { type: "slide", duration: 500 },
      position: { horizontal: "center", vertical: "top" },
      hideAfter: 5000,
      type: { style: "warning", icon: true },
    });
  }
  showErrorNotification(message: string){
    this.notificationService.show({
      content: message,
      animation: { type: "slide", duration: 500 },
      position: { horizontal: "center", vertical: "top" },
      hideAfter: 5000,
      type: { style: "error", icon: true },
    });
  }
  showInfoNotification(message: string){
    this.notificationService.show({
      content: message,
      animation: { type: "slide", duration: 500 },
      position: { horizontal: "center", vertical: "top" },
      hideAfter: 5000,
      type: { style: "info", icon: true },
    });
  }
  showSuccessNotification(message: string){
    this.notificationService.show({
      content: message,
      animation: { type: "slide", duration: 500 },
      position: { horizontal: "center", vertical: "top" },
      type: { style: "success", icon: true },
    });
  }
}
